import instagram from "../images/Instagram_icon.png";
import tiktok from "../images/tiktok_logo.png";
import youtube from "../images/YouTube_icon.png";
import logo from "../images/favicon.ico";
import Copyright from "./copyright";

export default function Footer() {
  return (
    <div>
      <footer className="footer">
        <div className="colum">
          <div className="img">
            <a
              href="https://www.instagram.com/masterclass_005/"
              target="_blank"
            >
              <img src={instagram} alt="Instagram" />
              <br />
              Instagram
            </a>
          </div>
        </div>
        <div className="colum">
          <div className="img">
            <a href="https://www.tiktok.com/@masterclass_005" target="_blank">
              <img src={tiktok} style={{ borderRadius: "3px" }} alt="TikTok" />
              <br />
              TikTok
            </a>
          </div>
        </div>
        <div className="colum">
          <div className="img">
            <a
              href="https://www.youtube.com/channel/UCXN3C-k4uohtYFIhuLvuOkQ"
              target="_blank"
            >
              <img src={youtube} alt="YouTube" />
              <br />
              YouTube
            </a>
          </div>
        </div>
        <div className="colum">
          <div className="img">
            <a href="https://masterclass005.com/">
              <img src={logo} alt="Website" />
              <br />
              Website
            </a>
          </div>
        </div>
      </footer>
      <Copyright />
    </div>
  );
}
